import { Box, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import LibraryAccordion from "./LibraryAccordion";
import { useSelector } from "react-redux";
import { darkTheme } from "../../theme/Theme";
import NoRecordFounds from "../../utils/NoRecordsFound";
import Loading from "../../utils/Loader";

export default function LibraryTabView({ pageData, loading }) {
  const isMobile = useMediaQuery("max-width:600px");
  const isDarkTheme = useSelector((state) => state.theme);

  const validSections = pageData?.filter(
    (section) =>
      (section.documents && section.documents.length > 0) ||
      (section.videos && section.videos.length > 0) ||
      (section.links && section.links.length > 0)
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        marginBottom: "25px",
        background: isDarkTheme ? darkTheme.backgroundColorLayer1 : "#FBFCFE",
        padding: isMobile ? 0 : "16px",
        borderRadius: "16px",
        boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.2)",
      }}
    >
      {validSections?.length === 0 && <NoRecordFounds />}
      {validSections?.map((section) => (
        <LibraryAccordion
          key={section.subjectId}
          data={section}
          subPageId={section.subjectId}
          data-testid="library-accordion"
        />
      ))}

      {loading && <Loading />}
    </Box>
  );
}
